import React from 'react';
import { useAsync } from 'react-use';
import Amplify from '@noths/amplify';

type User = { status: 'idle' | 'logged-out' | 'logged-in' };

export function useUser(): User {
  const [user, setUser] = React.useState<User>({ status: 'idle' });

  useAsync(async () => {
    if (user.status === 'idle') {
      try {
        await Amplify.Auth.currentAuthenticatedUser();

        setUser({ status: 'logged-in' });
      } catch (_noCurrentUser) {
        setUser({ status: 'logged-out' });
      }
    }
  }, [user.status]);

  return user;
}
